var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#60a5fa",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 48,
    x2: 70,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 100,
    x2: 70,
    y2: 152
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 100,
    x2: 150,
    y2: 46
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 100,
    x2: 150,
    y2: 154
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#93c5fd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 48,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 100,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 152,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 46,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 154,
    r: 9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkOutline);
export default __webpack_public_path__ + "static/media/mark-outline.d2e5f691572d1a21292be829f39e9c67.svg";
export { ForwardRef as ReactComponent };